import { Button } from "@mui/material";
import React from "react";
interface Props {
  handleResetFilter: () => void;
  resetSelectedCategories?: () => void;
  width: string;
}
function FilterResetButton({
  handleResetFilter,
  resetSelectedCategories,
  width,
}: Props) {
  return (
    <Button
      onClick={() => {
        handleResetFilter();
        if (resetSelectedCategories !== undefined) {
          resetSelectedCategories();
        }
      }}
      sx={{
        width: width,
        color: "#FD3300",
        fontSize: "16px",
        fontWeight: "700",
        textTransform: "none",
        fontFamily: "'Repro', sans-serif",
      }}
      variant="text"
    >
      Reset
    </Button>
  );
}
export default FilterResetButton;